import React, { useEffect, useRef, useState } from 'react'
import productsLogic from '../functions/logic/productsLogic'
import t from '../translations/i18n'
import LoginRegister from '../components/modals/loginRegister'
import RestorePassword from '../components/modals/RestorePassword'
import { useCart } from '../functions/context/CartProvider'
import { Link } from 'react-router-dom'
import '../scss/navbar.scss'

const NavBar = () => {
  const {
    cartItems,
    removeFromCart,
    getTotalItems,
    isCartOpen,
    toggleCart,
    closeCart
  } = useCart()

  const totalItems = getTotalItems()

  const token = localStorage.getItem('authToken')
  const envio = parseFloat(localStorage.getItem('envio')) || 0
  const discountAmount = parseFloat(localStorage.getItem('discountAmount')) || 0
  const [categorias, setCategorias] = useState([])
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    getCategorias()
  }, [])

  const getCategorias = async () => {
    try {
      const response = await productsLogic.getFiltersLogic()

      if (response.success) {
        setCategorias(response.data.categorias || [])
      }
    } catch (error) {
      setCategorias([])
    }
  }

  const categoryMenuRef = useRef(null)
  const [isDragging, setIsDragging] = useState(false)

  const dragData = useRef({
    startX: 0,
    scrollLeft: 0
  })

  const handleCategoryMouseDown = (e) => {
    const element = categoryMenuRef.current

    if (!element) return

    setIsDragging(true)

    dragData.current = {
      startX: e.pageX - element.offsetLeft,
      scrollLeft: element.scrollLeft
    }
  }

  const handleCategoryMouseMove = (e) => {
    if (!isDragging) return

    const element = categoryMenuRef.current

    if (!element) return

    const x = e.pageX - element.offsetLeft
    const walk = (x - dragData.current.startX) * 1.5

    element.scrollLeft = dragData.current.scrollLeft - walk
  }

  const handleCategoryMouseUp = () => {
    setIsDragging(false)
  }

  const handleLogout = () => {
    localStorage.clear()
    window.location.href = '/home'
  }

  const calculateTotal = () => {
    const total =
      cartItems.reduce((total, item) => {
        const itemTotal =
          item.precio_descuento > 0
            ? item.precio_descuento * item.quantity
            : item.price * item.quantity
        const iva =
          item.precio_descuento > 0
            ? item.iva_descuento * item.quantity
            : item.iva
        return total + itemTotal + iva
      }, 0) +
      envio -
      discountAmount
    return total.toFixed(2)
  }

  return (
    <>
      <div
        className={`mobile-menu-overlay ${
          isMobileMenuOpen ? 'easybuy-mobile-menu-overlay-open' : ''
        }`}
        onClick={() => setIsMobileMenuOpen(false)}
      />
      <LoginRegister />
      <RestorePassword />
      <div
        className={`mobile-menu-container mobile-menu-light ${
          isMobileMenuOpen ? 'easybuy-mobile-menu-open' : ''
        }`}
      >
        <div className="mobile-menu-wrapper">
          <button
            type="button"
            className="mobile-menu-close"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Cerrar menú"
          >
            <i className="icon-close"></i>
          </button>
          <ul className="nav nav-pills-mobile nav-border-anim" role="tablist">
            <li className="nav-item">
              <a
                className="nav-link active"
                id="mobile-menu-link"
                data-toggle="tab"
                href="#mobile-menu-tab"
                role="tab"
                aria-controls="mobile-menu-tab"
                aria-selected="true"
              >
                Menu
              </a>
            </li>
          </ul>
          <div className="tab-content">
            <div
              className="tab-pane fade show active"
              id="mobile-menu-tab"
              role="tabpanel"
              aria-labelledby="mobile-menu-link"
            >
              <nav className="mobile-nav">
                <ul className="mobile-menu">
                  {categorias.map((categoria) => (
                    <li key={categoria.id}>
                      <a
                        href={
                          global.PRODUCTSEARCH +
                          '?categoria=' +
                          categoria.nemonico_cat
                        }
                      >
                        {categoria.nombre}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <header className="header">
        <div className="header-top">
          <div className="container-fluid">
            <div className="header-left">
              <div className="header-dropdown">
                <a href="!#" onClick={(e) => e.preventDefault()}>
                  Español
                </a>
                <div className="header-menu">
                  <ul>
                    <li>
                      <a href="!#" onClick={(e) => e.preventDefault()}>
                        Inglés
                      </a>
                    </li>
                    <li>
                      <a href="!#" onClick={(e) => e.preventDefault()}>
                        Español
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="header-right">
              <ul className="top-menu">
                <li>
                  <a href="!#" onClick={(e) => e.preventDefault()}>
                    Links
                  </a>
                  <ul>
                    <li>
                      <Link to={global.ABOUT}>{t('about.about_easybuy')}</Link>
                    </li>
                    <li>
                      <Link to={global.CONTACT}>
                        {t('about.contact_easybuy')}
                      </Link>
                    </li>
                    {!token ? (
                      <li>
                        <a href="#signin-modal" data-toggle="modal">
                          <i className="icon-user"></i>
                          {t('auth.login_easybuy')}
                        </a>
                      </li>
                    ) : (
                      <li className="nav-item dropdown">
                        <a
                          href="!#"
                          className="nav-link dropdown-toggle"
                          id="userDropdown"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i className="icon-user"></i> Perfil{' '}
                          <i className="icon-down-open"></i>
                        </a>
                        <div
                          className="dropdown-menu dropdown-menu-right"
                          aria-labelledby="userDropdown"
                        >
                          <Link
                            className="dropdown-item"
                            to={global.USERPERFIL}
                          >
                            {t('auth.user_profile')}
                          </Link>
                          <Link className="dropdown-item" to={global.ENVIOFACT}>
                            {t('auth.user_addrress')}
                          </Link>
                          <Link className="dropdown-item" to={global.HISTORY}>
                            {t('auth.user_history')}
                          </Link>
                          <div className="dropdown-divider"></div>
                          <a
                            className="dropdown-item"
                            href="!#"
                            onClick={(e) => {
                              e.preventDefault()
                              handleLogout()
                            }}
                          >
                            {t('auth.user_logout')}
                          </a>
                        </div>
                      </li>
                    )}
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="header-middle sticky-header">
          <div className="container-fluid">
            <div className="header-left">
              <button
                type="button"
                className="mobile-menu-toggler"
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  setIsMobileMenuOpen(true)
                }}
                aria-label="Abrir menú"
              >
                <span className="sr-only">Toggle mobile menu</span>
                <i className="icon-bars"></i>
              </button>
              <Link to="/home" className="logo">
                <img
                  src={process.env.PUBLIC_URL + '/assets/images/logo.png'}
                  alt="Molla Logo"
                  width="105"
                  height="25"
                />
              </Link>
            </div>
            <div className="header-category-menu">
              <button className="header-category-trigger">
                <i className="icon-menu"></i>
                Categorías
              </button>

              <ul
                ref={categoryMenuRef}
                onMouseDown={handleCategoryMouseDown}
                onMouseMove={handleCategoryMouseMove}
                onMouseUp={handleCategoryMouseUp}
                onMouseLeave={handleCategoryMouseUp}
              >
                {categorias.map((categoria) => (
                  <li key={categoria.id}>
                    <a
                      href={
                        global.PRODUCTSEARCH +
                        '?categoria=' +
                        categoria.nemonico_cat
                      }
                    >
                      {categoria.nombre}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className="easybuy-mobile-products-link">
              <a href={global.PRODUCTSEARCH}>
                {t('products.view_more_products')}
                <i className="icon-long-arrow-right"></i>
              </a>
            </div>
            <div className="header-right">
              <div
                className={`dropdown cart-dropdown ${isCartOpen ? 'show' : ''}`}
              >
                <a
                  href="!#"
                  onClick={(e) => {
                    e.preventDefault()
                    toggleCart()
                  }}
                  className="dropdown-toggle"
                  aria-expanded={isCartOpen}
                >
                  <i className="icon-shopping-cart"></i>
                  <span className="cart-count">{totalItems}</span>
                </a>
                <div
                  className={`dropdown-menu dropdown-menu-right ${
                    isCartOpen ? 'show' : ''
                  }`}
                >
                  <div className="dropdown-cart-products">
                    {cartItems.length === 0 ? (
                      <p>{t('shopping.Empty_cart')}</p>
                    ) : (
                      cartItems.map((item) => (
                        <div className="product" key={item.id}>
                          <div className="product-cart-details">
                            <h4 className="product-title">
                              <a href="!#" onClick={(e) => e.preventDefault()}>
                                {item.name}
                              </a>
                            </h4>
                            <span className="cart-product-info">
                              {item.precio_descuento > 0 ? (
                                <>
                                  <span className="cart-product-price">
                                    <span
                                      style={{
                                        textDecoration: 'line-through',
                                        color: 'red'
                                      }}
                                    >
                                      ${item.price.toFixed(2)}
                                    </span>
                                  </span>
                                  <span className="cart-product-price">
                                    ${item.precio_descuento.toFixed(2)}
                                  </span>
                                </>
                              ) : (
                                <span className="cart-product-price">
                                  ${item.price.toFixed(2)}
                                </span>
                              )}
                              <span className="cart-product-qty">
                                {' '}
                                x {item.quantity}
                              </span>
                            </span>
                          </div>
                          <figure className="product-image-container">
                            <a href="!#" className="product-image">
                              <img src={`${item.imageUrl}`} alt={item.name} />
                            </a>
                          </figure>
                          <a
                            href="!#"
                            onClick={(e) => {
                              e.preventDefault()
                              removeFromCart(item.id)
                            }}
                            className="btn-remove"
                            title="Remove Product"
                          >
                            <i className="icon-close"></i>
                          </a>
                        </div>
                      ))
                    )}
                  </div>
                  <div className="dropdown-cart-total">
                    <span>{t('shopping.Total')}</span>
                    <span className="cart-total-price">
                      ${calculateTotal()}
                    </span>
                  </div>
                  <div className="dropdown-cart-action">
                    <Link to={global.VIEWCART} className="btn btn-primary">
                      Ver Carrito
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  )
}

export default NavBar
